<template>
    <report-list-view :filterable="filterable">
        <template slot="tableColumns">
            <veui-table-column field="id"
                title="组件名称/ID">
                <template slot-scope="props">
                    <veui-span>
                        {{props.item.name}}
                        <br>
                        {{props.item.instanceId}}
                    </veui-span>
                </template>
            </veui-table-column>
            <veui-table-column field="previewUrl"
                title="组件缩略图"
                width="140">
                <template slot-scope="props">
                    <div class="img-container" :style="{backgroundImage: `url(${https(props.item.previewUrl)})`}"/>
                </template>
            </veui-table-column>
            <!-- 组件; v-if判断必须加到column上不然不会销毁造会成duplicate key错误-->
            <veui-table-column field="associatedTypeLabel"
                title="所属物料类型"
                width="100"/>
            <veui-table-column field="associatedId"
                title="所属物料名称/ID">
                <template slot-scope="props">
                    <veui-span>
                        {{props.item.associatedName}}
                        <br>
                        {{props.item.associatedId}}
                    </veui-span>
                </template>
            </veui-table-column>
            <veui-table-column field="associatedStatusLabel"
                title="所属物料状态"
                width="100">
                <template slot-scope="props">
                    <veui-span :class="props.item.associatedStatusColor">
                        {{props.item.associatedStatusLabel}}
                    </veui-span>
                </template>
            </veui-table-column>

            <veui-table-column field="pv" title="展现" width="85"/>
            <veui-table-column field="click" title="点击" width="85"/>
            <veui-table-column field="clickRatioPercent" title="点击率" width="85"/>
            <veui-table-column field="operation" title="其他" width="110">
                <template slot-scope="props">
                    <template v-if="isBaseReport">
                        <veui-button ui="link primary" @click="$emit('detail', props.item.instanceId)">详细数据</veui-button>
                    </template>
                    <template v-else>
                        <veui-button ui="link primary" @click="$emit('linkreport', props.item.instanceId)">子链点击率</veui-button>
                    </template>

                    <veui-button ui="link" @click="showTrend(props.item.instanceId, `${props.item.name}—趋势曲线`)">
                        趋势曲线 <veui-icon name="eye"/>
                    </veui-button>
                </template>
            </veui-table-column>
        </template>

        <template slot="after">
            <report-chart-dialog :open.sync="chartDialogVisible"
                :title="chartName"
                :chart-data="this.store.trendData"
                report-type="base"/>
        </template>
    </report-list-view>
</template>

<script>
import ListView from './ReportListView';
import 'veui-theme-one-icons/eye';
import Model from './ComponentListModel';
import {httpsTransform} from '@/common/utils';
import {Column, Button, Span, Icon} from 'veui';
import ReportChartDialog from './ReportChartDialog';
import createView from '@baidu/ve-ria/views/createView';

export default createView(ListView, Model, {
    name: 'component-list-view',
    components: {
        ReportChartDialog,
        'veui-table-column': Column,
        'veui-button': Button,
        'veui-span': Span,
        'veui-icon': Icon
    },
    props: {
        filterable: Boolean,
        isBaseReport: Boolean
    },
    data() {
        return {
            chartDialogVisible: false,
            chartName: ''
        };
    },
    methods: {
        async showTrend(componentInstanceId, name) {
            await this.store.requestTrendData({componentInstanceId});
            this.chartDialogVisible = true;
            this.chartName = name;
        },
        https(value) {
            return httpsTransform(value);
        }
    }
});
</script>
